module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_guide-e59834bd30778ad01135825ecc3c9ab4.svg";